const CustomFieldType = {
    Text: 'text',
    Textarea: 'textarea',
    Number: 'number',
    Date: 'date',
    Radio: 'radio',
    Checkbox: 'checkbox',
}

export default CustomFieldType;
